import { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { chatDateTime, chatUserLastMessageDateTime } from '../../../utils/dateTimeConverter';
import ChatHeader from '../Component/ChatComponents/ChatHeader';
import { IconSparkles } from '@tabler/icons-react';

const emojiOptions = [
    { label: 'Not Satisfied', emoji: '😞', value: '1' },
    { label: 'Neutral', emoji: '🙂', value: '2' },
    { label: 'Satisfied', emoji: '😄', value: '3' },
];

const ChatFeedback = () => {

    const [loading, setLoading] = useState({
        userList: false,
        messages: false
    })
    const [allMessages, setAllMessages] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null)
    const [userList, setUserList] = useState({
        count: 0,
        items: []
    });
    const [page, setPage] = useState(1);
    const chatBoxRef = useRef(null);

    const getUserList = async () => {
        setLoading({ ...loading, userList: true });
        let resp = await getApi(urlApi.getChatFeedbackList);
        setLoading({ ...loading, userList: false });
        if (resp?.responseCode === 200) {
            setUserList({
                count: resp?.data?.count,
                items: resp?.data?.items
            });
        } else {
            setUserList({
                count: 0,
                items: []
            })
        }
    }

    useEffect(() => {
        getUserList();
        return () => { }
    }, []);

    const onUserTileClick = async (userData) => {
        setLoading({ ...loading, messages: true });
        setSelectedUser(userData);
        setPage(1);
        setLoading({ ...loading, messages: false });
    }

    const getOldMessage = async () => {
        setLoading({ ...loading, messages: true });
        let resp = await getApi(urlApi.getOldMessages + selectedUser?._id + "?page=" + page + "&limit=25");
        setLoading({ ...loading, messages: false });
        if (resp?.responseCode === 200) {
            setAllMessages((prev) => {
                let newData = [...resp?.data, ...prev]
                return newData
            })
            if (page == 1) {
                setTimeout(() => scrollToBottom(), 0);
            }
        }
    }

    useEffect(() => {
        if (selectedUser) {
            getOldMessage();
        }
    }, [selectedUser, page]);

    useEffect(() => {
        if (page == 1 && chatBoxRef.current) {
            setTimeout(() => {
                scrollToBottom();
            }, 0);
        }
    }, [allMessages, page])

    const handleChatScroll = (e) => {
        if (e.target.scrollTop === 0) {
            setPage((prev) => prev + 1);
            chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight - 300;
        }
    }

    const scrollToBottom = () => {
        const el = chatBoxRef.current;
        if (el) {
            el.scrollTop = el.scrollHeight;
        }
    }

    return (
        <div className='flex h-full'>
            <div className="bg-white w-[280px]">
                {/* <div className="flex p-2 gap-2 outline outline-1 outline-gray-100">
                    <p>All</p>
                    <IconFilter className='ms-auto' />
                    <IconSortAscending color='var(--primary)' />
                </div> */}
                <div className='max-h-[calc(100vh-130px)] h-full !py-2 overflow-x-hidden overflow-y-auto'>
                    {userList?.count > 0 ?
                        userList?.items?.map((item, index) => {
                            return (
                                <div key={item?._id} onClick={() => onUserTileClick(item)} className='max-w-[280px] w-full'>
                                    <FeedbackUserTile key={index} userData={item} selectedUser={selectedUser} />
                                </div>
                            )
                        })
                        : (loading.userList ? <div className='h-full flex flex-col gap-3 items-center justify-center text-xs'>
                            <Spinner size='sm' />
                            <p>Loading...</p>
                        </div> :
                            <div className='h-full flex flex-col gap-3 items-center justify-center text-xs'>
                                <p>No Feedback Found</p>
                            </div>)
                    }
                </div>
            </div>

            <div className="h-full bg-gray-100 p-2 border-l flex-1">
                <div className="flex flex-col">
                    {selectedUser && <ChatHeader selectedUser={selectedUser} page={"FEEDBACK"} />}
                    <div className="text-lg p-2 overflow-y-auto h-[calc(100vh-280px)]" ref={chatBoxRef} onScroll={handleChatScroll}>
                        {loading.messages ? <div className='h-full flex flex-col gap-3 items-center justify-center text-xs'>
                            <Spinner size='sm' />
                            <p>Loading...</p>
                        </div> :
                            allMessages?.map((item, i) => {
                                return (
                                    <div key={i} className={`${(item?.senderType == 1 || item?.senderType == 3) ? 'bg-blue-900 ms-auto' : 'bg-[#424242]'} flex flex-col min-w-[100px] w-max max-w-[300px] !px-3 !py-1.5 mb-2 rounded-xl`}>
                                        {item?.senderType == 3 &&
                                            <div className='flex items-center gap-2 !mb-1'>
                                                <IconSparkles size={18} className='text-green-600' />
                                                <p className='text-[10px] font-semibold text-green-600'>AI Generated</p>
                                            </div>}
                                        <p className='text-white text-sm !mb-0 leading-snug break-words'>{item?.message}</p>
                                        <p className='text-[10px] text-gray-200 self-end leading-none'>{chatDateTime(item?.createdAt)}</p>
                                    </div>
                                )
                            })}
                    </div>
                    {selectedUser &&
                        <div className="relative text-center">
                            <hr />
                            <div className="flex gap-2 items-center justify-center px-4 py-8 bg-white rounded-xl shadow-md text-sm break-all">
                                {selectedUser?.feedbackText}
                            </div>
                            {/* show only one emoji according to selectedUser.feedback */}
                            {selectedUser?.feedback && <div className="absolute top-[-25px] left-1/2 -translate-x-1/2 text-5xl">
                                {emojiOptions.find(option => option.value == selectedUser?.feedback)?.emoji}
                            </div>}
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default ChatFeedback

export const FeedbackUserTile = ({ userData, selectedUser }) => {
    return (
        <div className={`flex !p-2 !gap-3 items-center border-b cursor-pointer hover:bg-gray-100 ${selectedUser?._id === userData?._id ? "bg-gray-200" : ""}`}>
            <img src={userData?.profilePic || "https://img.freepik.com/premium-vector/character-avatar-isolated_729149-194801.jpg"} alt="" className='h-9 w-9 object-cover rounded-full' />
            <div>
                <p className='text-sm font-semibold break-words'>{userData?.visitorName} | #{userData?.chatSessionCount}</p>
                <p className='text-[10px] text-gray-500 max-line-1 break-words max-w-[100px] overflow-hidden'>{userData?.feedbackText} </p>
            </div>

            <div className='self-start ms-auto text-center'>
                <div className='flex items-center !gap-0.5 mb-0.5'>
                    <div className={`${userData?.status == 2 ? 'bg-green-700' : 'bg-primary'} h-1.5 w-1.5 rounded-full`}></div>
                    <p className={`text-[8px] ${userData?.status == 2 ? 'text-green-700' : 'text-primary'}`}>{chatUserLastMessageDateTime(userData?.createdAt)}</p>
                </div>
                {userData?.feedback && <p className='ms-auto mb-0 text-2xl'>{emojiOptions.find(option => option.value == userData?.feedback)?.emoji}</p>}
            </div>
        </div>
    )
}
